import { AuthService } from '../../services/auth/auth.service';
import { Component, Input, OnInit } from '@angular/core';
import { MenuItemsService } from '../../services/menu-items/menu-items.service';
import { ClienteService } from '../../services/cliente/cliente.service';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { Menu } from 'src/app/@shared/models/menu.model';
import { StorageService } from '../../services/storage/storage.service';
import { MatDialog } from '@angular/material/dialog';
// import { ModalPerfilComponent } from './modal-perfil/modal-perfil.component';
import { deleteMapCookie } from 'src/app/services/garagem/operacoes/operacoes.service';
import { ModalSugestoesComponent } from './modal-sugestoes/modal-sugestoes.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ManutencaoVestaSugestoesService } from 'src/app/services/manutencao-vesta-sugestoes/manutencao-vesta-sugestoes.service';
import { ModalAlertaComponent } from './modal-alerta/modal-alerta.component';
import { UsuarioListRequest, UsuarioService } from 'src/app/services/usuario/usuario.service';
import { ModalPerfilComponent } from './modal-perfil/modal-perfil.component';
import { FormControl, FormGroup } from '@angular/forms';
import { ModalPesquisaMenuComponent } from './modal-pesquisa-menu/modal-pesquisa-menu.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})

export class HeaderComponent implements OnInit {
  @Input() featureId: string;
  @Input() items: Menu[];
  public usuario: any;
  public customCollapsedHeight = '48px';
  public customExpandedHeight = '48px';
  public req: UsuarioListRequest = new UsuarioListRequest();
  emailResposta: string;
  comunicados: any[];
  company: any = {};
  user: any = {};
  alerts: any;
  isLoading = true;
  sugestoesTotais;
  habilitarInclusao: boolean = false;
  habilitarPesquisa: boolean = false;

  menuItems = [];
  clientId = null;
  cliente: any = {};

  constructor(
    public clienteService: ClienteService,
    public authService: AuthService,
    public snackBar: MatSnackBar,
    public serviceSugestoes: ManutencaoVestaSugestoesService,
    public activatedRoute: ActivatedRoute,
    public router: Router,
    private usuarioService: UsuarioService,
    public dialog: MatDialog,
    public menu: MenuItemsService
  ) { }

  searchForm = new FormGroup({
    search: new FormControl()
  })

  get search() { return this.searchForm.get('search').value }

  ngOnInit() {
    this.featureId = "cadastro.home-vesta.manutencao-vesta-sugestoes";
    this.authService
      .checkFeature(`${this.featureId}.novo`)
      .subscribe((temPermissao) => {
        if (temPermissao === true) this.habilitarInclusao = true;
      });
    this.usuario = StorageService.getPerfilUsuario();
    this.getUserPermissions();
    this.loadSugestoes();

  }

  private getUserPermissions() {
    this.menu.getMenus().subscribe(
      (response: Menu[]) => this.menuItems = response,
      (error: HttpErrorResponse) => {
        console.error(error);
      });
  }

  onlyFirstName(name) {
    return name ? name.replace(/ .*/, '') : '';
  }

  openResponsiveMenu() {
    const menu = document.querySelector('.responsive-menu-content');
    menu.classList.toggle('open');
  }

  logout() {
    this.authService.logout().subscribe(s => {
      this.router.navigate(['/login']).then(() => {
        window.location.reload();
      });
      localStorage.clear();
      deleteMapCookie();
    });
  }

  abrirModalPerfil() {
    this.usuario = StorageService.getPerfilUsuario();
    const dialogRef = this.dialog.open(ModalPerfilComponent, {
      width: '540px',
      minHeight: '275px',
      data: {
        usuario: this.usuario
      },
    });
  }

  public abrirModalPesquisa(items: Menu[]) {
    if (!this.search) {
      return this.openSnackBar("O campo de pesquisa não pode ser vazio!", 'OK', 5000, 'danger-snackbar');
    }
    const dialogRef = this.dialog.open(ModalPesquisaMenuComponent, {
      width: '650px',
      data: { items: items, search: this.search }
    })
  }

  public abrirModalSugestoes() {
    this.usuario = StorageService.getPerfilUsuario();
    this.req = {
      paginaAtual: 1,
      itensPorPagina: 10,
      usuario: this.usuario.username,
      nome: this.usuario.nome
    };
    this.usuarioService
      .getUserProfileList(this.req)
      .subscribe(
        (response: any) => {
          this.emailResposta = response[0].eMail;
        },
        (err: HttpErrorResponse) => {
          console.error(err);
          this.openSnackBar(
            "Ocorreu um erro ao enviar sua sugestão.",
            "OK",
            3000,
            "danger-snackbar"
          );
        }
      )
      .add(() => {
        this.isLoading = false;
      });
    setTimeout(() => {
      if (!this.validarEmail(this.emailResposta) || this.emailResposta === 'ab@ab.com') {
        const dialogRef = this.dialog.open(ModalAlertaComponent, {
          width: '540px',
          data: {
            texto: `Usuário com email inválido ou inexistente. Para enviar sugestões, entre em contato com o suporte para atualização do cadastro.`
          },
        });
      } else {
        const dialogRef = this.dialog.open(ModalSugestoesComponent, {
          width: '540px',
          minHeight: '275px',
          panelClass: 'modal-sugestoes',
          data: {
            usuario: this.usuario
          },
        });
        dialogRef.afterClosed().subscribe(res => { if (res == 'OK') this.loadSugestoes() })
      }
    }, 200);
  }

  public validarEmail(email: string): boolean {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(email);
  }

  public async loadSugestoes() {
    this.isLoading = true;
    const obj = {
      usuario: this.usuario.nome,
      paginaAtual: 1,
      itensPorPagina: 999999,
    };
    return this.serviceSugestoes
      .consultar(obj)
      .toPromise()
      .then(
        (response: any) => {
          const data = response;
          this.sugestoesTotais = data[0]?.totalCount;
          this.isLoading = false;
        },
        (err: HttpErrorResponse) => {
          this.isLoading = false;
          this.openSnackBar(
            "Erro ao carregar sugestões!",
            "OK",
            5000,
            "danger-snackbar"
          );
        }
      );
  }

  openSnackBar(message: string, action: string, duration: number, panelClass?: string): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }
}
